const EMPTY_CELL = {
    count: 0,
    hours: 0,
    wtl: 0,
    lkv: 0,
    toegepast: 0,
};

export const cell = (scan, targetGroup, year) =>
    scan?.[targetGroup]?.[year] ?? EMPTY_CELL;

export const toInteger = value => {
    const parsed = parseInt(value === '' || value == null ? '0' : value, 10);

    return Number.isNaN(parsed) ? 0 : parsed;
};

export const sumOverYears = (scan, targetGroup, years, field) =>
    years.reduce(
        (total, year) => total + cell(scan, targetGroup, year)[field],
        0
    );

export const potentie = (scan, targetGroup, year) => {
    const { hours, lkv } = cell(scan, targetGroup, year);
    const conversion = scan?.[targetGroup]?.conversion ?? 0;

    return Math.ceil(hours * (conversion / 100) * lkv);
};

export const customerConversion = (scan, targetGroup, years) => {
    const count = sumOverYears(scan, targetGroup, years, 'count');

    if (count <= 0) {
        return 0;
    }

    return (sumOverYears(scan, targetGroup, years, 'wtl') / count) * 100;
};

export const withValue = (scan, targetGroup, year, field, value) => {
    const group = { ...(scan?.[targetGroup] ?? {}) };

    if (year === null) {
        group[field] = value;
    } else {
        group[year] = { ...EMPTY_CELL, ...group[year], [field]: value };
    }

    return { ...scan, [targetGroup]: group };
};
